const Style = {
  label: "text-sm lg:text-2xl font-medium text-black ml-2 mb-2",

  input: "px-[18px] py-2 lg:py-3 rounded-full lg:text-2xl w-full text-black border border-slate-300",

  error: "text-[0.75em] lg:text-lg text-red-600 font-semilbold mt-2 ml-2",

  submitButton: "px-6 py-2 bg-[#CF2027] gap-4 rounded-full items-center justify-center flex hover:bg-[#921a1e] transition-colors lg:text-2xl text-white",

  cancelButton: `px-6 py-2 bg-[#FFFFFF] text-black border border-slate-300 hover:border hover:border-red-500 rounded-full lg:text-2xl `,

  container: "flex flex-col md:flex-row justify-end gap-1 md:gap-3",

  button: `bg-[#006999] p-3 text-sm flex justify-center
  items-center gap-2 shadow-md rounded-md hover:bg-[#1F3A5F] transition-colors`,

  button2: `bg-white text-slate-600 p-3 text-sm flex justify-center border border-slate-400
  items-center gap-2 rounded-md hover:bg-slate-300 transition-colors shadow-sm`,

  iconButton: `bg-white p-[0.9rem] text-sm flex justify-center border-2
  items-center rounded-md hover:bg-[#d8d8d8] transition-colors`,

  header: "relative border-dotted border-slate-100 border-b items-center",

  title: "float:left m-0 text-lg font-semibold",

  link: "text-[0.75em] text-blue-500 text-end"
};

export default Style;
